/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Tulu370B = ({ color = 'primary', aspectRatio = '1034/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Tulu3-70B" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Tulu370B, Tulu370B as default };
